"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var moment = require("moment");
var api_request_1 = require("../../api_request");
var classNames = require("classnames");
var url_helpers_1 = require("../../shared/url_helpers");
var bulk_sale_modal_button_1 = require("./bulk_sale_modal_button");
var RowAction;
(function (RowAction) {
    RowAction["ADDING"] = "adding";
    RowAction["ADDED"] = "added";
    RowAction["REMOVING"] = "removing";
    RowAction["REMOVED"] = "removed";
    RowAction["ERROR"] = "error";
})(RowAction || (RowAction = {}));
var DATE_FORMAT = 'll';
function renderI18nCount(i18nKey, count) {
    return I18n.t("discovery.selling.bulkSale." + i18nKey, {
        formattedCount: I18n.toNumber(count),
        count: count,
    });
}
function FeaturedTag() {
    return (React.createElement("span", { className: "bulk-sale-row__featured-tag" }, I18n.t('discovery.selling.bulkSale.featuredSale')));
}
function SaleType(_a) {
    var curatedSet = _a.curatedSet;
    if (!curatedSet.label)
        return null;
    var classes = classNames('bulk-sale-row__type', { 'bulk-sale-row__type--reverb': !curatedSet.lp_only }, { 'bulk-sale-row__type--lp': curatedSet.lp_only });
    return (React.createElement("h4", { className: classes, "data-title-label": true },
        curatedSet.featured && React.createElement(FeaturedTag, null),
        curatedSet.label));
}
function rowActionReducer(state, action) {
    switch (action.type) {
        case 'setAdding':
            return tslib_1.__assign(tslib_1.__assign({}, state), { currentAction: RowAction.ADDING });
        case 'setAdded':
            return tslib_1.__assign(tslib_1.__assign({}, state), { currentAction: RowAction.ADDED });
        case 'setRemoving':
            return tslib_1.__assign(tslib_1.__assign({}, state), { currentAction: RowAction.REMOVING });
        case 'setRemoved':
            return tslib_1.__assign(tslib_1.__assign({}, state), { currentAction: RowAction.REMOVED });
        case 'setError':
            return tslib_1.__assign(tslib_1.__assign({}, state), { currentAction: RowAction.ERROR });
        case 'setDefault':
        default:
            return tslib_1.__assign(tslib_1.__assign({}, state), { currentAction: null });
    }
}
function shouldDisableButtons(rowState) {
    return (rowState.currentAction === RowAction.ADDING ||
        rowState.currentAction === RowAction.ADDED ||
        rowState.currentAction === RowAction.REMOVING ||
        rowState.currentAction === RowAction.REMOVED);
}
function AddButton(_a) {
    var curatedSet = _a.curatedSet, rowState = _a.rowState, handleAddListings = _a.handleAddListings, disabled = _a.disabled;
    if (curatedSet.add_count < 1 || curatedSet.status === bulk_sale_modal_button_1.SaleStatus.ENDED)
        return null;
    var i18nKey = curatedSet.used_only ? 'addUsedListings' : 'addListings';
    var addButtonText = rowState.currentAction === RowAction.ADDING
        ? I18n.t('discovery.selling.bulkSale.addingListings')
        : renderI18nCount(i18nKey, curatedSet.add_count);
    return (React.createElement("button", { className: "bulk-sale-row__add", onClick: handleAddListings, disabled: disabled }, addButtonText));
}
function RemoveButton(_a) {
    var curatedSet = _a.curatedSet, handleRemoveListings = _a.handleRemoveListings, disabled = _a.disabled;
    if (curatedSet.remove_count < 1)
        return null;
    return (!disabled && (React.createElement("div", { className: "bulk-sale-row__remove" },
        React.createElement("span", { className: "bulk-sale-row__remove-text" }, renderI18nCount('listingsAlreadyAdded', curatedSet.remove_count)),
        React.createElement("button", { className: "button-as-link", onClick: handleRemoveListings, disabled: disabled, "data-remove-button": true }, I18n.t('discovery.selling.bulkSale.remove')))));
}
function SubmittedMessage(_a) {
    var curatedSet = _a.curatedSet, rowState = _a.rowState;
    if (rowState.currentAction === RowAction.ADDED) {
        return (React.createElement("p", { className: "bulk-sale-row__submit-message bulk-sale-row__submit-message--success" },
            renderI18nCount('listingsAdded', curatedSet.add_count),
            React.createElement("span", { className: "bulk-sale-row__submit-submessage" }, I18n.t('discovery.selling.bulkSale.pleaseWaitAdding'))));
    }
    if (rowState.currentAction === RowAction.REMOVED) {
        return (React.createElement("p", { className: "bulk-sale-row__submit-message bulk-sale-row__submit-message--success" },
            renderI18nCount('listingsRemoved', curatedSet.remove_count),
            React.createElement("span", { className: "bulk-sale-row__submit-submessage" }, I18n.t('discovery.selling.bulkSale.pleaseWaitRemoving'))));
    }
    if (rowState.currentAction === RowAction.ERROR) {
        return (React.createElement("p", { className: "bulk-sale-row__submit-message bulk-sale-row__submit-message--failure" }, I18n.t('discovery.selling.bulkSale.error')));
    }
    return null;
}
function DetailsTable(_a) {
    var curatedSet = _a.curatedSet;
    var discountPercent = curatedSet.discount_percent
        ? curatedSet.discount_percent + "%"
        : I18n.t('discovery.selling.bulkSale.noDiscountPercent');
    return (React.createElement("table", { className: "bulk-sale-row__details" },
        React.createElement("tbody", null,
            React.createElement("tr", { className: "bulk-sale-row__detail" },
                React.createElement("td", null, I18n.t('discovery.selling.bulkSale.datesActive')),
                React.createElement("td", null, I18n.t('discovery.selling.bulkSale.dateSummary', {
                    startsAt: moment(curatedSet.starts_at).format(DATE_FORMAT),
                    endsAt: moment(curatedSet.ends_at).format(DATE_FORMAT),
                }))),
            React.createElement("tr", { className: "bulk-sale-row__detail" },
                React.createElement("td", null, I18n.t('discovery.selling.bulkSale.discount')),
                React.createElement("td", null, discountPercent)),
            React.createElement("tr", { className: "bulk-sale-row__detail" },
                React.createElement("td", null, I18n.t('discovery.selling.bulkSale.status')),
                React.createElement("td", { className: classNames('bulk-sale-row__status', {
                        'bulk-sale-row__status--active': curatedSet.status === bulk_sale_modal_button_1.SaleStatus.LIVE,
                        'bulk-sale-row__status--upcoming': curatedSet.status === bulk_sale_modal_button_1.SaleStatus.UPCOMING,
                        'bulk-sale-row__status--ended': curatedSet.status === bulk_sale_modal_button_1.SaleStatus.ENDED,
                    }) }, I18n.t("discovery.selling.bulkSale.displayStatus." + curatedSet.status))))));
}
function BulkSaleRow(_a) {
    var curatedSet = _a.curatedSet, visible = _a.visible, queryString = _a.queryString;
    var canAddSale = !curatedSet.unavailable_to_add_reason;
    var _b = React.useReducer(rowActionReducer, { currentAction: null }), rowState = _b[0], dispatch = _b[1];
    function handleAddListings(e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        dispatch({ type: 'setAdding' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_request_1.default.V3.post(url_helpers_1.default.curatedSetAddListings(curatedSet.id, queryString))];
                    case 2:
                        _a.sent();
                        dispatch({ type: 'setAdded' });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        handleError();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function handleRemoveListings(e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        dispatch({ type: 'setRemoving' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_request_1.default.V3.post(url_helpers_1.default.curatedSetRemoveListings(curatedSet.id, queryString))];
                    case 2:
                        _a.sent();
                        dispatch({ type: 'setRemoved' });
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        handleError();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function handleError() {
        dispatch({ type: 'setError' });
    }
    return (visible && (React.createElement("div", { className: "bulk-sale-row" },
        React.createElement("div", { className: "bulk-sale-row__inner" },
            React.createElement("div", { className: "bulk-sale-row__info" },
                React.createElement(SaleType, { curatedSet: curatedSet }),
                React.createElement("h3", { className: "bulk-sale-row__name" },
                    curatedSet.name,
                    curatedSet.status === bulk_sale_modal_button_1.SaleStatus.LIVE &&
                        curatedSet._links.self.href && (React.createElement("a", { href: curatedSet._links.self.href, className: "bulk-sale-row__sale-link", target: "_blank", rel: "noopener noreferrer" }, I18n.t('discovery.selling.bulkSale.viewSale')))),
                curatedSet.additional_information && React.createElement("div", { className: "bulk-sale-row__affirm-text" }, curatedSet.additional_information),
                React.createElement(DetailsTable, { curatedSet: curatedSet }),
                !canAddSale &&
                    React.createElement("p", { className: "bulk-sale-row__notice bulk-sale-row__notice--error" }, curatedSet.unavailable_to_add_reason),
                curatedSet.used_only &&
                    React.createElement("p", { className: "bulk-sale-row__notice bulk-sale-row__notice--warning" }, I18n.t('discovery.selling.bulkSale.usedOnlyHint'))),
            React.createElement("div", { className: "bulk-sale-row__actions" },
                React.createElement(AddButton, { curatedSet: curatedSet, rowState: rowState, handleAddListings: handleAddListings, disabled: !canAddSale || shouldDisableButtons(rowState) }),
                React.createElement(RemoveButton, { curatedSet: curatedSet, handleRemoveListings: handleRemoveListings, disabled: shouldDisableButtons(rowState) }),
                React.createElement(SubmittedMessage, { curatedSet: curatedSet, rowState: rowState }))))));
}
exports.default = BulkSaleRow;
//# sourceMappingURL=bulk_sale_row.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/selling/sales/bulk_sale_row.js
// module id = FGWl
// module chunks = 20 21